import type {
  ContextualMenuGroup,
  ContextualMenuItem,
  ContextualMenuItemWithIcon,
  ContextualMenuItemWithImage,
} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-contextual-menu/ai-prompt-box-contextual-menu.types';
import {ContextualMenuItemGraphicType} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-contextual-menu/ai-prompt-box-contextual-menu.types';
import type {AiVideoFilterKey} from '@Panels/ai-video-panel/ai-video-panel.types';
import {AiVideoAspectRatio, AiVideoAudio, AiVideoCameraAngle, AiVideoTextSetting} from '@Panels/ai-video-panel/ai-video-panel.types';

export interface AiVideoSettingsPillProps {
  filterKey: AiVideoFilterKey;
  group: ContextualMenuGroup;
  isAudioOff: boolean;
  onSelectItem: (itemIndex: number) => void;
}

export const CAMERA_ANGLE_DEFAULT_VALUE: string = AiVideoCameraAngle.DEFAULT;
export const ASPECT_RATIO_PORTRAIT_VALUE: string = AiVideoAspectRatio.PORTRAIT;
export const AUDIO_OFF_VALUE: string = AiVideoAudio.NO;
export const AUDIO_ON_VALUE: string = AiVideoAudio.YES;
export const SPOKEN_TEXT_SETTING_VALUES: string[] = [AiVideoTextSetting.CHARACTER_SPEAKS, AiVideoTextSetting.VOICEOVER];

export const AI_VIDEO_SETTINGS_PILL_MODAL_PANEL_ID = 'ai-video-settings-pill-modal';

export const PILL_ICON_QUALITY = 'icon-hd';
export const PILL_ICON_ASPECT_RATIO_PORTRAIT = 'icon-portrait';
export const PILL_ICON_ASPECT_RATIO_LANDSCAPE = 'icon-landscape';
export const PILL_ICON_AUDIO_ON = 'icon-sound';
export const PILL_ICON_AUDIO_OFF = 'icon-sound-off';
export const PILL_ICON_CAMERA_ANGLE = 'icon-video';
export const PILL_ICON_TEXT_SETTING = 'icon-text';
export const SELECTED_ROW_CHECK_ICON = 'icon-check';

export const isContextualMenuItemWithIcon = (item: ContextualMenuItem): item is ContextualMenuItemWithIcon => {
  return 'graphicType' in item && (item as ContextualMenuItemWithIcon).graphicType === ContextualMenuItemGraphicType.ICON;
};

export const isContextualMenuItemWithImage = (item: ContextualMenuItem): item is ContextualMenuItemWithImage => {
  return 'graphicType' in item && (item as ContextualMenuItemWithImage).graphicType === ContextualMenuItemGraphicType.IMAGE;
};
